"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  for (var _len = arguments.length, picked = Array(_len), _key = 0; _key < _len; _key++) {
    picked[_key] = arguments[_key];
  }

  return function (a, b, interpolate) {
    var a_picked = {},
        b_picked = {};
    for (var i = 0; i < picked.length; i++) {
      a_picked[picked[i]] = a[picked[i]];
      b_picked[picked[i]] = b[picked[i]];
    }
    var interpolate_t = interpolate(a_picked, b_picked);
    return function (t) {
      return _extends({}, b, interpolate_t(t));
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/join-transition/dist/interpolatePicked.js
// module id = 263
// module chunks = 0